var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeadsHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 30,
    viewBox: "0 0 21 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.706 6.801C3.706 3.05 6.753 0 10.5 0c3.748 0 6.794 3.05 6.794 6.801-.014 3.68-2.89 6.658-6.55 6.787H10.642a1.154 1.154 0 0 0-.315 0c-3.747-.129-6.622-3.107-6.622-6.787zM2.938 18.11c4.191-2.734 10.977-2.734 15.139 0 1.879 1.235 2.908 2.91 2.923 4.718 0 1.823-1.044 3.498-2.923 4.748-2.088 1.381-4.833 2.072-7.577 2.072-2.744 0-5.489-.69-7.577-2.072C1.044 26.34 0 24.665 0 22.857c0-1.808 1.044-3.498 2.938-4.748zm8.68 5.85h1.865c.611 0 1.119-.5 1.119-1.102 0-.603-.508-1.103-1.119-1.103h-1.864v-1.837a1.119 1.119 0 0 0-2.238 0v1.837H7.517c-.611 0-1.119.5-1.119 1.103 0 .602.508 1.102 1.119 1.102h1.864v1.837a1.119 1.119 0 0 0 2.238 0V23.96z",
    fill: "url(#a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 6.176,
    y1: 5.668,
    x2: 24.132,
    y2: 18.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48AFCC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsHome);
export default __webpack_public_path__ + "static/media/leadsHome.6bbbab7611e540d994c1e3434e201329.svg";
export { ForwardRef as ReactComponent };